<select
  [id]="id"
  [ngModel]="value"
  (ngModelChange)="valueChange.emit($event)"
  [disabled]="disabled"
  (blur)="blur.emit()"
  [class.nothing]="isNoValueSelected"
  [title]="value"
  class="form-select"
>
  <optgroup label="test" [placeholder]="placeholder"></optgroup>
  @for (option of normalizedOptions; track option.id) {
  <option [ngValue]="option.id" [title]="option.value">
    {{ option.value }}
  </option>
  } @for (group of groups; track group.label) {
  <optgroup [label]="group.label">
    @for (option of group.options; track option.id) {
    <option [ngValue]="option.id" [title]="option.value">
      {{ option.value }}
    </option>
    }
  </optgroup>
  }
</select>
